import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import ExportInfoMessage from "../../../table-actions-panel/components/ExportInfoMessage/ExportInfoMessage";
import PanelSubmitButton from "../../../table-actions-panel/components/PanelSubmitButton/PanelSubmitButton";
import SelectionDropdownView from "../../../table-actions-panel/components/SelectionDropdown/SelectionDropdown";

export const StyledTitle = styled.span`
    ${mixins.setFontVariant("button", colorsPalettes.carbon["0"])};
    user-select: none;
`;

export const StyledSelectionDropdown = styled(SelectionDropdownView)`
    margin-left: 20px;
`;

export const StyledExportQuotaTagContainer = styled(Flex)`
    margin-left: 12px;
    &:hover {
        cursor: pointer;
    }
`;

export const StyledSubmitButton = styled(PanelSubmitButton)`
    margin-left: 12px;
`;

export const StyledInfoMessage = styled(ExportInfoMessage)`
    margin-left: 16px;
`;
